"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asyncFilterParallel = asyncFilterParallel;
exports.default = void 0;

var _asyncIterable = require("../../internal/async-iterable");

var _parallelRunner = require("../../internal/parallel-runner");

async function* asyncFilterParallel(iterable, concurrency = 4, func) {
  let c = 0;
  const mapped = new _parallelRunner.ParallelRunner(iterable[Symbol.asyncIterator](), async item => ({
    item,
    value: await func(item, c++)
  }), concurrency);

  for await (const item of mapped) {
    if (item.value) {
      yield item.item;
    }
  }
}

var _default = (0, _asyncIterable.asyncIterableCurry)(asyncFilterParallel, {
  minArgs: 1,
  maxArgs: 2
});

exports.default = _default;